@if (items$ | async; as items) { @if (items.length > 0) {
<div class="container js-product-carousel" [attr.data-name]="title$ | async">
  <label [ngClass]="activeLanguage$ | async">{{ title$ | async }}</label>
  @if (normal) {
  <app-product-carousel-normal
    [items$]="items$"
    [dealerPrices]="dealerPrices"
    [location]="carouselLocation"
  ></app-product-carousel-normal>
  } @if (!normal) {
  <app-product-carousel-big [items]="items" [dealerPrices]="dealerPrices"></app-product-carousel-big>
  }
</div>
} }
